import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { AreaAjoutFormModalComponent } from './area-ajout-form-modal/area-ajout-form-modal.component';
import { AreaFormComponent } from './area-form/area-form.component';
import { DetailAreaComponent } from './detail-area/detail-area.component';
import { ListAreaComponent } from './list-area/list-area.component';

@NgModule({
	declarations: [
		ListAreaComponent,
		AreaAjoutFormModalComponent,
		AreaFormComponent,
		DetailAreaComponent
	],
	imports: [SharedModule, GestionDonneesModule],
	providers: []
})
export class AreaModule {}
